import {createTableState, normalizePagination} from '@/core/services/Helper'

const state = () => ({
    table: createTableState(),
    filterData: undefined
})

const getters = {}

const actions = {
    async get({state, commit}, {page, filterData}) {
        commit('setLoading', true)
        state.filterData = filterData

        let params = {page: page?.current, page_limit: page?.pageSize}
        if (state.filterData) params = {...params, ...state.filterData}

        const res = await this._vm.axios.get(this._vm.endpoint.get('admin_group'), {params})
        const {data, meta} = res.data

        commit('updateTableData', data)
        commit('updatePagination', normalizePagination(meta))

        setTimeout(() => commit('setLoading', false), 250)
    },

    refresh({state, dispatch}) {
        dispatch('get', {page: state.table.pagination, filterData: state.filterData})
    },

    async show(_, {id}) {
        const response = await this._vm.axios.get(this._vm.endpoint.get('admin_group') + '/' + id)
        return response.data.data
    },

    async create(_, {data}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('admin_group'), data)
        return response.data
    },

    async put(_, {id, data}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('admin_group') + '/' + id, data)
        return response.data
    },

    // grubu çoğalt
    async duplicate(_, {sourceId}) {
        const response = await this._vm.axios.post(this._vm.endpoint.get('admin_group') + '/duplicate', {source_id: sourceId})
        return response.data
    },

    // izin kataloğu (tüm endpoint'ler)
    async endpoints() {
        const response = await this._vm.axios.get(this._vm.endpoint.get('admin_group_endpoint'))
        return response.data.data
    },

    // bir grup için endpoint izinlerini güncelle
    async saveEndpoint(_, {groupId, endpoint_id, method}) {
        const response = await this._vm.axios.put(this._vm.endpoint.get('admin_group_endpoint') + '/' + groupId, {endpoint_id, method})
        return response.data
    },

    async delete({dispatch}, {id}) {
        let successDeleted = []
        if (id.length === 0) {
            this._vm.$message.warning(this._vm.$t('messages.selectRow'))
        } else {
            for (let i = 0; i < id.length; i++) {
                const {data} = await this._vm.axios.delete(this._vm.endpoint.get('admin_group') + '/' + id[i])
                if (data.status) {
                    this._vm.$message.success(this._vm.$t('messages.deleteOk'))
                    successDeleted.push(id[i])
                } else {
                    this._vm.$message.error(data.message)
                }
            }
            dispatch('refresh')
            return successDeleted
        }
    },
}

const mutations = {
    setLoading(state, val) {
        state.table.loading = val
    },
    updatePagination(state, pagination) {
        state.table.pagination = pagination
    },
    updateTableData(state, data) {
        state.table.data = data
    }
}

export default {namespaced: true, state, getters, actions, mutations}
